import React, { ChangeEvent } from "react";
import { FormSectionElements, FormSubSections, ProgramContainer } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import { HintExpansionComponent } from "../odsCalloutBox/HintExpansionComponent";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { gaEvent } from "../../utilities/GAUtils";
import axios from "axios";


interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
}

interface State {


}
export class RadioButtonComponent extends React.Component<Props, State> {

    HtmlToReactParser = require('html-to-react').Parser;
    constructor(props: Props) {
        super(props);

        let field = this.props.field;
        FormValidationUtils.runJavascript(field);

    }

    async componentDidMount(): Promise<void> {
        const field = this.props.field;

        if (field.LovAPI) {

            const getUrl = field.LovAPI;
            let response;

            if (field.parent.parent.parent.UseProxy == "Y") {
                let transferPayload = {
                    url: getUrl,
                    httpMethod: 'GET',
                    payload: ""
                }

                response = await axios.post(process.env.LAYOUT_API_URL + "/tponTransfer", transferPayload);

            } else {
                response = await axios.get(getUrl);
            }
            field.ListOfLOVValues = response.data;
            console.log(field);
        }
    }

    getGaTrackingId = () => {
        let section = this.props.field.parent;
        let trackingId = '';
        while (section && !section.GATrackingID) {
            section = section.parent;
        }

        return section?.GATrackingID;
    }

    setSelectedRadio = (e: ChangeEvent<HTMLInputElement>) => {
        let field = this.props.field;
        field.Value = e.target.value;

        // let group = e.target.parentElement
        // while (group && group.nodeName !== 'fieldset') {
        //     group = group.parentElement;
        // }

        // if (!group) return;
        // if (!e.target.value && field.Optional !== 'Y') {
        //      group.setAttribute('aria-invalid', 'true');
        //      group.setAttribute('aria-describedby', 'text-input-odometer-example-error-text');
        // } else {
        //     group.removeAttribute('aria-invalid');
        //     group.removeAttribute('aria-describedby');
        // }

        FormValidationUtils.validateRadioButton(field);
        FormValidationUtils.runJavascript(field);
        //   this.props.callbackElement(field.parent.parent.parent.parent);
        const subSection: FormSubSections = field.parent as FormSubSections;

        // subSection.ListOfFormSectionElements.forEach(async ele => {
        //     let list = ele.ListOfLOVValues?.filter(p => p.FilterField == field.LoadBindName && p.FilterValue.indexOf(field.Value) != -1);
        //     if (field.LoadBindBase == null || field.LoadBindBase == '') {
        //         list = ele.ListOfLOVValues?.filter(p =>  p.FilterField == field.LoadBindName && p.FilterValue.split(',').indexOf(field.Value) != -1);
        //         console.log(list);
        //     }
        // });

        gaEvent({
            action: 'click',
            category: 'Radio option',
            label: (this.props.isEng ? field.ENUTitle : field.FRATitle) + (field.LoadBindName ?? ''),
            value: e.target.value
        }, this.getGaTrackingId());

        this.props.callbackElement(subSection.parent.parent);
    }

    generateLabel = () => {
        const field = this.props.field;
        let labelControlArray = [];
        const title = this.props.isEng ? field.ENUTitle : field.FRATitle;
        const hint = this.props.isEng ? field.Hint : field.HintFR;
        const requireLabel = this.props.isEng ? "(required)" : "(obligatoire)";
        const root = this.props.field.parent.parent.parent as ProgramContainer;
        const useAsterisks = root.UseAsterisks == "Y";
        if (field.Optional == "N") {
            labelControlArray.push(
                <div key={'fdLbl_' + field.Id}>
                    {(
                        <h1 className="ontario-label" tabIndex={-1} id={`label_${field.LoadBindName}`}>
                            {title}<span className="ontario-label__flag">{useAsterisks ? <span style={{ color: 'red' }}>*</span> : <span className='ontario-label__flag'>
                                {title ? requireLabel : null}</span>}
                            </span>
                            {field.TooltipENU && (<i role='tooltip' title={field.TooltipENU} className="pi pi-info-circle"></i>)}
                        </h1>
                    )}

                </div>);
        } else {
            labelControlArray.push(
                <div key={'fdLbl_' + field.Id}>
                    <div className="ontario-label" >{title} <span className="ontario-label__flag">{this.props.isEng ? "(optional)" : "(facultatif)"}</span>
                        {field.enuToolTip ? <i title={field.TooltipENU} className="pi pi-info-circle"></i> : null}
                    </div>
                </div>);
        }
        return labelControlArray;
    }

    render() {
        let field = this.props.field;
        FormValidationUtils.runJavascript(field);
        if (!field.Visible) return null;

        const htmlToReactParser = new this.HtmlToReactParser();

        let editable = this.props.editable;

        let requiredField = this.props.requiredField;
        let controlArray = [];
        let title = this.props.title;

        if (editable) {
            var lovOptionList = [];
            field.ListOfLOVValues.forEach(lov => {
                let selectOptionName = (this.props.isEng ? lov.description : lov.FRADescription);
                if (selectOptionName === null || selectOptionName === '') {
                    selectOptionName = (this.props.isEng ? lov.code : lov.FRA);
                }
                let selectOptionValue = lov.code;
                let callOutBoxTitle = this.props.isEng ? lov.callOutBoxTitle : lov.callOutBoxTitleFRA;
                
                const callOutBoxBody = htmlToReactParser.parse(this.props.isEng ? lov.callOutBoxBody : lov.callOutBoxBodyFRA);
                let hintExpansionTitle = this.props.isEng ? lov.hintExpansionTitle : lov.hintExpansionTitleFRA;
                lovOptionList.push(
                    {
                        Sequence: lov.Sequence,
                        label: selectOptionName,
                        value: selectOptionValue,
                        hintExpansionTitle: hintExpansionTitle ? hintExpansionTitle : null,
                        callOutBoxType: lov.callOutBoxType ? lov.callOutBoxType : null,
                        callOutBoxTitle: callOutBoxTitle ? callOutBoxTitle : null,
                        callOutBoxBody: callOutBoxBody ? callOutBoxBody : null,
                        parent: lov.parent,
                        Visible: lov.Visible,
                        Script: lov.Script,
                    }
                );
            });
            const hintHtml = this.props.isEng ? field.Hint : field.HintFR;
            let hint;
            if (field.Hint || field.HintFR) {
                hint = htmlToReactParser.parse(hintHtml);
            }
            controlArray.push(
                <>
                    {hint && <>{this.generateLabel()}</>}
                    <fieldset className='ontario-margin-top-24-!' id={`${field.LoadBindName}`}>
                        {!hint && <legend>{this.generateLabel()}</legend>}
                        <div>
                            <LiveValidationErrMsg
                                field={this.props.field}
                                isEng={this.props.isEng}
                                key={"LiveValidationErrMsg_" + this.props.field.LoadBindName}
                            />
                        </div>
                        
                        {hint && <legend><div className="ontario-hint">{hint}</div></legend>}
                        {lovOptionList.map(val => {
                            if (val.Script) {
                                const customJSFunc = eval(`(${val.Script})`);
                                try {
                                    customJSFunc(val);
                                } catch (ex) {
                                    console.log(ex);
                                }
                            }
                            if (val.Visible == false) return null;

                            return (
                                <div className="ontario-radios__item" >
                                    <input id={field.LoadBindName + val?.label?.replace(/[^a-zA-Z]/g, '')}
                                        onChange={(e) => this.setSelectedRadio(e)}
                                        className={field.Valid ? "ontario-radios__input" : "ontario-radios__input ontario-radios__error"}
                                        type="radio"
                                        aria-labelledby={`label_${field.LoadBindName}`}
                                        value={val.value}
                                        name={field.LoadBindName}
                                        checked={this.props.field.Value == val.value}
                                    />
                                    <label htmlFor={field.LoadBindName + val.label?.replace(/[^a-zA-Z]/g, '')} id={field.LoadBindName + val.label?.replace(/[^a-zA-Z]/g, '') + "_label"}
                                        className="ontario-label ontario-radios__label">
                                        {val.label}
                                    </label>

                                    {val.callOutBoxType != null && <HintExpansionComponent
                                        isEng={this.props.isEng} Visible={field.Visible}
                                        field={field}
                                        calloutType={val.callOutBoxType}
                                        bodyMsg={val.callOutBoxBody}
                                        title={val.callOutBoxTitle}
                                        hintExpansionTitle={val.hintExpansionTitle}
                                    />}
                                </div>
                            )
                        })}
                    </fieldset>
                </>
            );
        } else {
            controlArray.push(
                <div className='pdf-two-column'>
                    <div>{title}<br></br>{htmlToReactParser.parse(this.props.field.Hint)}</div>
                    <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })}>{field.Value}</div>
                </div>
            );
        }


        return controlArray;

    }

}